namespace advisorop.components.advisor {

    export class InvestorLoginListController {

        public investorLogins:domains.IInvestor[];
        public dgInvestorLogins;
        public loginFromDate: Date;
        public loginToDate: Date;
        constructor(private advisorService: services.AdvisorService, private generalService: services.GeneralService) {

            this.dgInvestorLogins = {
                export: {
                    enabled: true,
                    fileName: "InvestorLogins"
                },
                bindingOptions: {
                    dataSource: "vm.investorLogins"
                },
                scrolling: {
                    mode: "standard",
                    useNative: true
                },
                //height: "350px",
                paging: { pageSize: 20 },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: true,
                allowColumnReordering: true,
                allowColumnResizing: true,
                stateStoring: {
                    enabled: true,
                    type: "localStorage",
                    storageKey: "dgInvestorLogins"
                },
                columnChooser: {
                    enabled: true,
                    title: "Select columns"
                },
                filterRow: { visible: true },
                headerFilter: { visible: false },
                noDataText: "Investor Not Found",
                searchPanel: {
                    visible: true,
                    width: 240,
                    placeholder: 'Search...'
                },
                columns: [
                    { dataField: 'fullName', caption: 'Name', width: 150, cellTemplate: 'colFullName' },
                    { dataField: 'statusDescription', caption: 'Status', width: 60 },
                    { dataField: 'contactEmail', caption: 'E-mail', visible: true, width: 250 },
                    { dataField: 'systemLogin.username', caption: 'Username', visible: true, width: 250 },
                    { dataField: 'systemLogin.loginStatusDesc', caption: 'Login stat.', visible: true, width: 70 },
                    { dataField: 'systemLogin.twoFactorEnabled', caption: '2FA', visible: true, width: 55, dataType: 'boolean' },
                    {
                        caption: 'Last Login', visible: true, dataType: 'date', format: 'MM/dd/yy hh:mm a', width: 105,
                        allowSorting: true, allowFiltering: true,
                        calculateCellValue: (investor) => {
                            if (!investor.systemLogin) {
                                return "";
                            }
                            if (!investor.systemLogin.lastLogin) {
                                return "";
                            }
                            return new Date(this.generalService.toUTCDateString(investor.systemLogin.lastLogin));
                        },
                        sortIndex: 0, sortOrder: "desc"
                    },
                    { dataField: 'loginCount', caption: 'Login Count', visible: true, width: 70 },
                ],
            };
        }

        toUTCDate(date: Date): Date {
            return new Date(date.getTime() + (date.getTimezoneOffset() * 60000))
        }

        loadInvestorLogins(): void {
            if (!this.loginFromDate || !this.loginToDate) {
                return;
            }
            this.advisorService.getInvestorLogins(this.toUTCDate(this.loginFromDate), this.toUTCDate(this.loginToDate)).success((data) => {
                this.investorLogins = data;
            }).error((data, status) => {
                toastr.error("Investors cannot be loaded. ERROR " + status + ":" + data);
            });
        };

        $onChanges(evt): void {
            for (var key in evt) {
                if (key === "loginToDate") {
                    this.loadInvestorLogins();
                }
                if (key === "loginFromDate") {
                    this.loadInvestorLogins();
                }
            }
        }
        $onInit(): void {
            this.loadInvestorLogins();
        }

    }

    class InvestorLoginList implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        //public $routeConfig: any;

        constructor() {
            this.bindings = {
                loginFromDate: "=",
                loginToDate: "=",
            };
            this.controller = ["advisorService", "generalService",InvestorLoginListController];
            this.controllerAs = "vm";
            this.templateUrl = 'spa/advisor-module/components/investor-login-list.html';
        }
    }
    angular.module(Constants.APP).component("investorLoginList", new InvestorLoginList());

}